/* eslint-disable */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import type { FC } from 'react';
import {Alert, Box, Collapse, Container, Grid, IconButton, Typography} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useIndicators from 'src/hooks/useIndicators';
import useAuth from 'src/hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
import { IdleTimerProvider } from 'react-idle-timer';
import DatePicker, {registerLocale} from "react-datepicker";
import es from "date-fns/locale/es";
registerLocale("es",es);
import { useStyles } from 'src/components/dashboard/style';
import 'react-datepicker/dist/react-datepicker.css'
import WidgetBalance from 'src/components/dashboard/overview/masterOverview/ComponentesPrior/WidgetBalance';
import PastelBalance from 'src/components/dashboard/overview/masterOverview/Charts/PastelBalance';
import TablaFinanciera from 'src/components/dashboard/overview/masterOverview/Tablas/TablaFinanciera';
import ChartCapitalTrabajoCicloEfectivo
  from "../../components/dashboard/overview/masterOverview/Charts/ChartCapitalTrabajoCicloEfectivo";
import ChartLineZoom from "../../components/dashboard/overview/masterOverview/Charts/ChartLineZoom";
import BarDonutBG from "../../components/dashboard/overview/masterOverview/Charts/BarDonutBG";
import {getZazacorpPrediction} from "../../components/bridges/BridgeBusiness";
import {addDays} from "date-fns";
import activoCorrienteIcon from "../../../src/assets/icons/activosCorrientesIcon.svg";
import pasivoUtilidadesIcon from "../../../src/assets/icons/pasivoUtilidadesIcon.svg";
import viewMoreIcon from "../../../src/assets/icons/viewMorePlainIcon.svg";
import BusinessIcon from "@material-ui/icons/Business";
import TablaPrior from 'src/components/dashboard/overview/masterOverview/Tablas/TablaPrior';

const OverviewBalanceGeneral: FC = () => {
  const classes = useStyles();
  const { getDashboardMaster, dashboardMaster, getTradeByBusiness } =
    useIndicators();
  const isMountedRef = useIsMountedRef();
  const { user } = useAuth();
  const [info, setInfo] = useState<any>();
  const { t } = useTranslation('dashboard');
  const date = new Date();
  let nextDate = new Date(date)
  nextDate.setFullYear(date.getFullYear() +1)
  const utc = date.getTime() + date.getTimezoneOffset() * 60000;
  const nd = new Date(utc + 3600000 * -5);
  const now = `${nd.getFullYear()}-${nd.getMonth() + 1}-${nd.getDate()}`;
  const dateNextMonth = new Date(date.setMonth(date.getMonth() + 1));
  const month = dateNextMonth.toLocaleString('es', { month: 'long' });
  const [valueCapitalTrabajo, setValueCapitalTrabajo] = useState([]);
  const [currentIndicator, setCurrentIndicator] = useState('CapAcc');
  const topRef = useRef(null);
  const bottomRef = useRef(null);
  const [goingUp, setGoingUp] = useState(false);
  const [displayAlert, setDisplayAlert] = useState(true);
  const [openTable, setOpenTable] = useState(false);
  const [tableBgRanges, setTableBgRanges] = useState({header: [], rows: []});
  const [ifPercentage, setIfPercentage] = useState({
    'Estructura de Capital': 0,
    'Apalancamiento': 0,
    'Acid Test': 0,
  });
  const prevScrollY = useRef(
    topRef.current !== null &&
      topRef.current.getBoundingClientRect() !== undefined
      ? topRef.current.getBoundingClientRect().y
      : 0
  );

  const [valueDate, setvalueDate] = useState(new Date());

  const executeScroll = () => {
    if (goingUp) {
      if (topRef.current === null) return;
      topRef.current.scrollIntoView();
      setGoingUp(false);
    } else if (!goingUp) {
      if (bottomRef.current === null) return;
      bottomRef.current.scrollIntoView();
      setGoingUp(true);
    }
  };

  const handleScroll = () => {
    if (topRef.current === null) return;
    const currentScrollY = topRef.current.getBoundingClientRect().y;
    if (prevScrollY.current < currentScrollY && goingUp) {
      setGoingUp(false);
    }
    if (prevScrollY.current > currentScrollY && !goingUp) {
      setGoingUp(true);
    }
    prevScrollY.current = currentScrollY;
  };

  const EtlStatus = async () => {
    try {
      if (user['rolDesc'] === 'master' || user['rolDesc'] === 'estandar') {
        const obj = {
          businessId: user.businessId.business_id,
          date: now,
        };
        await getDashboardMaster();
      }
    } catch (error) {
      console.error(error);
    }
  };

  function findValues(data, targetKeys) {
    let results = {};

    function traverse(node) {
      if (node.data && targetKeys.includes(node.data[0])) {
        results[node.data[0]] = node.data[1];
      }
      if (node.subRows && node.subRows.length > 0) {
        node.subRows.forEach(subRow => traverse(subRow));
      }
    }

    data.rows.forEach(row => traverse(row));
    return results;
  }

  function calculatePercentages(values) {
    const total = Object.values(values).reduce((acc, value) => (acc as number) + (value as number), 0);

    let percentages = {};
    for (const key in values) {
      percentages[key] = ((values[key] / (total as number)) * 100).toFixed(2) + '%';
    }

    return { total, percentages };
  };

  function extraerIndicadores(data) {
    console.log("dataIFDonuts", data)
    const indicadores = {
      "CCE (1)+(2)-(3)": 0,
      "Capital de Trabajo (activos corrientes - pasivos corrientes)":0,
      "Estructura de Capital": 0,
      "Acid Test": 0,
      "Apalancamiento": 0
    };
    data.rows.forEach(row => {
      row.subRows.forEach(subRow => {
        switch (subRow.data[0]) {
          case "Capital accionario/deuda":
            indicadores["Estructura de Capital"] = subRow.data[1];
            break;
          case "Acit test ((activos corrientes - inventario)/pasivos corrientes)":
            indicadores["Acid Test"] = subRow.data[1];
            break;
          case "Apalancamiento (deuda/capital)":
            indicadores["Apalancamiento"] = subRow.data[1];
            break;
        }
      });
    });

    return indicadores;
  };

  function extraerIndicadores2(data) {
    const indicadores = {
      "CCE (1)+(2)-(3)": 0,
      "Capital de Trabajo (activos corrientes - pasivos corrientes)":0,
      "Estructura de Capital": 0,
      "Acid Test": 0,
      "Apalancamiento": 0
    };
    data.rows.forEach(row => {
      row.subRows.forEach(subRow => {
        switch (subRow.data[0]) {
          case "Indice Corriente (activos corrientes/pasivos corrientes)":
            indicadores["Estructura de Capital"] = subRow.data;
            break;
          case "Acid test ((activos corrientes - inventario)/pasivos corrientes)":
            indicadores["Acid Test"] = subRow.data;
            break;
          case "Apalancamiento (deuda/capital)":
            indicadores["Apalancamiento"] = subRow.data;
            break;
          case "Capital de Trabajo (activos corrientes - pasivos corrientes)":
            indicadores["Capital de Trabajo (activos corrientes - pasivos corrientes)"] = subRow.data;
            break;
          case "CCE (1)+(2)-(3)":
            indicadores["CCE (1)+(2)-(3)"] = subRow.data;
            break;
        }
      });
    });

    return indicadores;
  };

  const buildIFGraph = async (data) => {
    const fechaBase = new Date(valueDate);
    const length = data.header.length;
    let datesArray = [];
    let tempDataEstructura = [];
    let tempDataAcidTest = [];
    let tempDataApalancamiento = [];
    let tempDataCapitalTrabajo = [];
    let tempDataConversionEfectivo = [];
    
    for (let i = 0; i < length; i++) {
      let futureDate = new Date(fechaBase.getFullYear(), fechaBase.getMonth(), fechaBase.getDate() + i);
      datesArray.push(futureDate.getTime()); // No division by 1000, to get milliseconds
    }
    data.rows.forEach(row => {
      row.subRows.forEach(subRow => {
        switch (subRow.data[0]) {
          case "Capital accionario/deuda":
          {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataEstructura.push(tempDateData);
            })
            setCapitalDataChart(tempDataEstructura);
          }
            break;
          case "Acit test ((activos corrientes - inventario)/pasivos corrientes)":
          {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataAcidTest.push(tempDateData);
            })
            setAcidTestChart(tempDataAcidTest);
          }
            break;
          case "Apalancamiento (deuda/capital)":
          {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataApalancamiento.push(tempDateData);
            })
            setApalancamientoChart(tempDataApalancamiento);
          }
            break;
          case "Capital de Trabajo (activos corrientes - pasivos corrientes)":
          {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataCapitalTrabajo.push(tempDateData);

            })
            setCapitalTrabajo(tempDataCapitalTrabajo);

          }
            break;
          case "CCE (1)+(2)-(3)":
          {
            const [, ...restOfData] = subRow.data;
            datesArray.map((date,index) => {
              const tempDateData = [date, restOfData[index]];
              tempDataConversionEfectivo.push(tempDateData);

            })
            setConversionEfectivo(tempDataConversionEfectivo);

          }
            break;
        }
      });
    });
  }

  const buildZazacorpTableJson = async (data) => {
    // Identificar todos los encabezados de fecha únicos en los datos
    let headerDates = [];
    data.forEach(item => {
      Object.keys(item).forEach(key => {
        const parts = key.split('_');
        if (parts.length === 2 && !isNaN(Number(parts[1]))) {
          if (!headerDates.includes(key)) {
            headerDates.push(key);
          }
        }
      });
    });
    // headerDates.sort(); // Para ordenar las fechas

    // Transformar las claves de fecha en fechas formateadas
    // const fechaBase = new Date(data[0].fecha_desde);
    const fechaBase = new Date(valueDate);
    let currentDate = fechaBase;
    const formattedDates = headerDates.map((date, index) => {
      if (index === 0) {
        return "Hoy"; // Primer encabezado como 'Today'
      }
      const day = parseInt(date.split('_')[1], 10);
      const newDate = addDays(currentDate, 1);
      currentDate = newDate;
      return `${newDate.getDate().toString().padStart(2, '0')}/${(newDate.getMonth() + 1).toString().padStart(2, '0')}/${newDate.getFullYear()}`;
    });


    // Crear un mapa para mantener referencias a las filas basadas en índices
    const indexToRowMap = new Map();

    // Crear la estructura de filas y subfilas
    const rows = [];

    data.forEach(item => {
      const rowData = [item.name, ...headerDates.map(date => item[date] === null ? 0 : item[date])];

      const indexParts = item.index.split('.');
      const row = { data: rowData, subRows: [] };
      indexToRowMap.set(item.index, row);

      if (indexParts.length === 1) {
        // Es una categoría principal
        rows.push(row);
      } else {
        // Es una subcategoría
        const parentIndex = indexParts.slice(0, -1).join('.');
        const parentRow = indexToRowMap.get(parentIndex);
        if (parentRow) {
          parentRow.subRows.push(row);
        }
      }
    });

    return {header: formattedDates, rows};
  };

 

  async function getPredictions() {
    try {
      // const formattedDate = valueDate.toISOString().split('T')[0];
      const yearToday = valueDate.getFullYear();
      const monthToday = String(valueDate.getMonth() + 1).padStart(2, '0');
      const dayToday = String(valueDate.getDate()).padStart(2, '0');
      const formattedDateToday = `${yearToday}-${monthToday}-${dayToday}`;
      const response = await getZazacorpPrediction(formattedDateToday,formattedDateToday,'bg_predict');
      const responseIF = await getZazacorpPrediction(formattedDateToday,formattedDateToday,'if_predict');
      const tableJson = await buildZazacorpTableJson(response.resultRangeDates);
      const tableIF = await buildZazacorpTableJson(responseIF.resultRangeDates);
      const tableIFEndYear = await buildZazacorpTableJson(responseIF.resultUntilEndYear);

      const toDate = addDays(valueDate, 5);
      // const formattedToDate = toDate.toISOString().split('T')[0];
      const yearToDate = toDate.getFullYear();
      const monthToDate = String(toDate.getMonth() + 1).padStart(2, '0');
      const dayToDate = String(toDate.getDate()).padStart(2, '0');
      const formattedDateToDate = `${yearToDate}-${monthToDate}-${dayToDate}`;
      const responseBgRange = await getZazacorpPrediction(formattedDateToday, formattedDateToDate, 'bg_predict');
      const tableJsonBgRange = await buildZazacorpTableJson(responseBgRange.resultRangeDates);
    
      buildBgTable(tableJsonBgRange)
      const ifData = await extraerIndicadores(tableIF);
      const ifData2 = await extraerIndicadores2(tableIFEndYear)
    
      await buildIFGraph(tableIFEndYear);
      setIfPercentage(ifData);
      const targetKeysActivos = [
        "Activos Corrientes",
        "Activos No Corrientes",
        
      ]
      let resTargetKeysActivos = findValues(tableJson, targetKeysActivos)

      resTargetKeysActivos['Total Activos'] = resTargetKeysActivos['Activos No Corrientes'] + resTargetKeysActivos['Activos Corrientes']

      setActivos(activos.map((i) => {
        return {...i, value: resTargetKeysActivos[i.name]}
      }))


      const targetKeysPasivos = [
       
        "Pasivos Corrientes",
        "Pasivo No Corriente",
      
      ]

      let restTargetKeysPasivos = findValues(tableJson, targetKeysPasivos)

      restTargetKeysPasivos['Total Pasivos'] = restTargetKeysPasivos['Pasivos Corrientes'] + restTargetKeysPasivos['Pasivo No Corriente']

      setPasivos(pasivos.map((i) => {
        return {...i, value: restTargetKeysPasivos[i.name]}
      }))


      const targetKeyUtilidadesRetenidas = [
       
        "Utilidades Retenidas",
        "Patrimonio",
      
      ]

      let restTargetKeyUtilidadesRetenidas = findValues(tableJson, targetKeyUtilidadesRetenidas)


      console.log("utilidadesRetenidas", restTargetKeyUtilidadesRetenidas)


      setUtilidadesRetenidas(utilidadesRetenidas.map((i) => {
        return {...i, value: restTargetKeyUtilidadesRetenidas[i.name]}
      }))


      const targetKeysActivosCorrientes = [
        "Inventario",
        "Cuentas y Documentos por Cobrar",
        "Efectivo y Equivalentes a Efectivo"
      ];
      let targetKeysPasivosCorrientesDeuda = [
        ["Cuenta por pagar SRI", "Cuentas por Pagar Proveedores", "Cuentas por Pagar Otros Proveedores", "Cuentas y Documentos por Pagar"],
        ["Obligaciones Con Instituciones Financieras (Corriente)", "Obligaciones con Instituciones Financieras Prestamo Bancario (corriente)", "Obligaciones con Instituciones Financieras Tarjeta de Credito"],
        ["Utilidades Retenidas"]
      ];
      let restargetKeysPasivosCorrientesDeuda = targetKeysPasivosCorrientesDeuda.map(i => Object.values(findValues(tableJson, i) as number[]).reduce((acc:number, val:number) => acc + val, 0))
      console.log("restargetKeysPasivosCorrientesDeuda", restargetKeysPasivosCorrientesDeuda)
      setPasivosCorrientesDeuda({...pasivosCorrientesDeuda, series: restargetKeysPasivosCorrientesDeuda})
      let valuesActivosCorrientes = findValues(tableJson, targetKeysActivosCorrientes);
      //let valuesPasivosCorrientes = findValues(tableJson, targetKeysActivosCorrientes);


      setActivosCorrientesHoy({...activosCorrientesDeHoy, series: [valuesActivosCorrientes["Inventario"],valuesActivosCorrientes["Efectivo y Equivalentes a Efectivo"],valuesActivosCorrientes["Cuentas y Documentos por Cobrar"] ]})
      


      //const { total, percentages } = calculatePercentages(values);
      
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    EtlStatus();
  }, []);

  useEffect(() => {
    setInfo(dashboardMaster);
  }, [dashboardMaster]);

  useEffect(() => {
    getPredictions();
  }, [valueDate]);

  useEffect(() => {
    window.addEventListener('wheel', handleScroll);

    return () => window.removeEventListener('wheel', handleScroll);
  }, [goingUp]);

  const onIdle = () => {
    window.location.reload();
  };

  const handleOnDateChange = (date: any) => {
    setvalueDate(date);
  }

  const handleOpenTable = (newValue) => {
    setOpenTable(prevState => !prevState);
  };

  const handleIndicator = (indicator) => {
    setCurrentIndicator(indicator);
  }

  // const activos = [
  //   { name: 'Total Activos Corrientes', value: 1146734.67 },
  //   { name: 'Total Activos No Corrientes', value: 238321.29 },
  //   { name: 'Total Activos', value: 1385055.96 },
  // ];

  // const pasivos = [
  //   { name: 'Totales Pasivo Corriente', value: 1146734.67 },
  //   { name: 'Totales Pasivo No Corrientes', value: 238321.29 },
  //   { name: 'Totales Pasivo', value: 1146734.67 },
  // ];

  // const utilidadesRetenidas = [
  //   { name: 'Utilidades Retenidas', value: 357906.06 },
  //   { name: 'Total Patrimonio', value: 1146734.67 },
  //   //{ name: 'Total Pasivo', value: 1146734.67 },

  // ];

  // const activosCorrientesDeHoy = {
  //   title: 'Activos Corrientes',
  //   series: [10, 30, 60],
  //   labels: ['Inventario', 'Efectivo', 'Cuentas por Cobrar'],
  // };


  // const buildZazacorpTableJson = async (data) => {
  //     //console.log("dataEr", data)
  //     // Identificar todos los encabezados de fecha únicos en los datos
  //     let headerDates = [];
  //     data.forEach(item => {
  //       Object.keys(item).forEach(key => {
  //         const parts = key.split('_');
  //         if (parts.length === 2 && !isNaN(Number(parts[1]))) {
  //           if (!headerDates.includes(key)) {
  //             headerDates.push(key);
  //           }
  //         }
  //       });
  //     });
  
  //     // headerDates.sort(); // Para ordenar las fechas
  
  //     // Transformar las claves de fecha en fechas formateadas
  //     // const fechaBase = new Date(data[0].fecha_desde);
  //     const fechaBase = new Date(valueFromDate);
  //     let currentDate = fechaBase;
  //     const formattedDates = headerDates.map((date, index) => {
  //       if (index === 0) {
  //         return "Hoy"; // Primer encabezado como 'Today'
  //       }
  //       const day = parseInt(date.split('_')[1], 10);
  //       const newDate = addDays(currentDate, 1);
  //       currentDate = newDate;
  //       return `${newDate.getDate().toString().padStart(2, '0')}/${(newDate.getMonth() + 1).toString().padStart(2, '0')}/${newDate.getFullYear()}`;
  //     });
  
  
  //     // Crear un mapa para mantener referencias a las filas basadas en índices
  //     const indexToRowMap = new Map();
  
  //     // Crear la estructura de filas y subfilas
  //     const rows = [];
  
  //     data.forEach(item => {
  //         const rowData = [item.name, ...headerDates.map(date => item[date] === null ? 0 : item[date])];
          
  //         const indexParts = item.index.split('.');
  //         const row = { data: rowData, subRows: [] };
  //         indexToRowMap.set(item.index, row);
  
  //         if (indexParts.length === 1) {
  //             // Es una categoría principal
  //             rows.push(row);
  //         } else {
  //             // Es una subcategoría
  //             const parentIndex = indexParts.slice(0, -1).join('.');
  //             const parentRow = indexToRowMap.get(parentIndex);
  //             if (parentRow) {
  //                 parentRow.subRows.push(row);
  //             }
  //         }
  //     });
  
  //     return {header: formattedDates, rows};
  //   };


  const buildBgTable = async (data) => {
    console.log("buildertable",data);
    let tempHeader = [
      "Balance General",
    ];
    let tempRows = [
      ["1. Activos",],
      ["1.1 Activo corriente",],
      ["1.1.1 Efectivo y Equivalentes de Efectivo",],
      ["1.1.2 Inventario",],
      ["1.1.3 Servicios y otros Pagos Anticipados",],
      ["1.1.4 Impuestos Corrientes"],
      ["1.1.5 Otros Activos Corrientes"],
      ["Total Activo Corriente"],
      ["Totales Activo No Corriente"],
      ["Total Activo"],
      ["2. Pasivos"],
      ["2.1 Pasivo Corriente"],
      ["2.1.1 Obligaciones Financieras"],
      ["2.1.2 Cuentas por Pagar"],
      ["2.1.3 Impuestos Corrientes"],
      ["2.1.4 Otros Pasivos Corrientes "],
      ["Totales Pasivo Corriente"],
      ["Totales Pasivo No Corriente"],
      ["Total Pasivos"],
      ["3. Patrimonio"],
    ];
    data.header.map((header,index) => {
      if (index === 0) {
        tempHeader.push("Hoy");
      } else {
        tempHeader.push(`${header}`);
      }
    })


    console.log("tempHeader", tempHeader)
    data.rows.map(row => {
      if (row.data[0] === "Costos de Venta y Produccion"){
        const [,...restOfData] = row.data;
        restOfData.map(costoData => {
          tempRows[0].push(costoData);
        })
      }
      if (row.data[0] === "Activos"){
        tempRows[0] = [...tempRows[0], ...row.data.slice(1)]
        tempRows[9] = [...tempRows[9], ...row.data.slice(1)]
        row.subRows.map(subRow => {
          if (subRow.data[0] === "Activos Corrientes") {
            tempRows[1] = [...tempRows[1], ...subRow.data.slice(1)]
            tempRows[7] = [...tempRows[7], ...subRow.data.slice(1)]
            subRow.subRows.map(subSubRow => {
              if (subSubRow.data[0] === "Efectivo y Equivalentes a Efectivo"){
                const [,...restOfData] = subSubRow.data;
                restOfData.map(gastosAdminData => {
                  tempRows[2].push(gastosAdminData);
                })
              }
              if (subSubRow.data[0] === "Inventario"){
                const [,...restOfData] = subSubRow.data;
                restOfData.map(gastosAdminData => {
                  tempRows[3].push(gastosAdminData);
                })
              }
              if (subSubRow.data[0] === "Servicios y otros Pagos Anticipados"){
                const [,...restOfData] = subSubRow.data;
                restOfData.map(gastosAdminData => {
                  tempRows[4].push(gastosAdminData);
                })
              }
              if (subSubRow.data[0] === "Activos por Impuestos Corrientes"){
                const [,...restOfData] = subSubRow.data;
                restOfData.map(gastosAdminData => {
                  tempRows[5].push(gastosAdminData);
                })
              }
              if (subSubRow.data[0] === "Otros Activos Corrientes"){
                const [,...restOfData] = subSubRow.data;
                restOfData.map(gastosAdminData => {
                  tempRows[6].push(gastosAdminData);
                })
              }
            })
          }else if(subRow.data[0] === "Activos No Corrientes"){
            tempRows[8] = [...tempRows[8], ...subRow.data.slice(1)]
          }
          
        })
      }
      if (row.data[0] === "Pasivos"){
        tempRows[10] = [...tempRows[10], ...row.data.slice(1)]
        tempRows[18] = [...tempRows[18], ...row.data.slice(1)]
        row.subRows.map(subRow => {
          if (subRow.data[0] === "Pasivos Corrientes") {
            tempRows[11] = [...tempRows[11], ...subRow.data.slice(1)]
            tempRows[16] = [...tempRows[16], ...subRow.data.slice(1)]
            subRow.subRows.map(subSubRow => {
              if (subSubRow.data[0] === "Obligaciones Con Instituciones Financieras (Corriente)"){
                const [,...restOfData] = subSubRow.data;
                restOfData.map(gastosAdminData => {
                  tempRows[12].push(gastosAdminData);
                })
              }
              if (subSubRow.data[0] === "Cuentas y Documentos por Pagar"){
                const [,...restOfData] = subSubRow.data;
                restOfData.map(gastosAdminData => {
                  tempRows[13].push(gastosAdminData);
                })
              }
              if (subSubRow.data[0] === "Impuestos Corrientes"){
                const [,...restOfData] = subSubRow.data;
                restOfData.map(gastosAdminData => {
                  tempRows[14].push(gastosAdminData);
                })
              }
              if (subSubRow.data[0] === "Otros Pasivos Corrientes"){
                const [,...restOfData] = subSubRow.data;
                restOfData.map(gastosAdminData => {
                  tempRows[15].push(gastosAdminData);
                })
              }
              
            })
          }else if(subRow.data[0] === "Pasivo No Corriente"){
            tempRows[17] = [...tempRows[17], ...subRow.data.slice(1)]
          }
          
        })
      }

      if (row.data[0] === "Patrimonio"){
        tempRows[19] = [...tempRows[19], ...row.data.slice(1)]
        // row.subRows.map(subRow => {
        //   if (subRow.data[0] === "Pasivos Corrientes") {
        //     tempRows[11] = [...tempRows[1], ...subRow.data.slice(1)]
        //     subRow.subRows.map(subSubRow => {
        //       if (subSubRow.data[0] === "Obligaciones Con Instituciones Financieras (Corriente)"){
        //         const [,...restOfData] = subSubRow.data;
        //         restOfData.map(gastosAdminData => {
        //           tempRows[12].push(gastosAdminData);
        //         })
        //       }
        //       if (subSubRow.data[0] === "Cuentas y Documentos por Pagar"){
        //         const [,...restOfData] = subSubRow.data;
        //         restOfData.map(gastosAdminData => {
        //           tempRows[13].push(gastosAdminData);
        //         })
        //       }
        //       if (subSubRow.data[0] === "Impuestos Corrientes"){
        //         const [,...restOfData] = subSubRow.data;
        //         restOfData.map(gastosAdminData => {
        //           tempRows[14].push(gastosAdminData);
        //         })
        //       }
        //       if (subSubRow.data[0] === "Otros Pasivos Corrientes"){
        //         const [,...restOfData] = subSubRow.data;
        //         restOfData.map(gastosAdminData => {
        //           tempRows[15].push(gastosAdminData);
        //         })
        //       }
              
        //     })
        //   }
          
        // })
      }
    })
    const tempTable = {
      header: tempHeader,
      rows: tempRows
    }

    setTableBgRanges(tempTable)
    
    console.log("tempTable", tempTable);
  }

  
  const dataTablaActualDelMes = {
    header: [
      "",
      "Actual del Mes",
    ],
    rows: [
      ["Ventas del Mes", 98627.35],
      ["COGS y Gastos del Mes", 43602.98],
      ["Utilidad Neta", 15292.11]
    ],
  };

 
  const [capitalDataChart, setCapitalDataChart] = useState([]);
  const [capitalTrabajo, setCapitalTrabajo] = useState([]);
  const [conversionEfectivo, setConversionEfectivo] = useState([]);
  const [apalancamientoChart, setApalancamientoChart] = useState([]);
  const [acidTestChart, setAcidTestChart] = useState([]);
  const [activosCorrientesDeHoy, setActivosCorrientesHoy] = useState({title: 'Activos Corrientes',
    series: [0, 0, 0],
    labels: ['Inventario', 'Efectivo', 'Cuentas por Cobrar'],})
  
  const [pasivosCorrientesDeuda, setPasivosCorrientesDeuda] = useState({   
    title: 'Pasivo Corrientes y Utilidades Retenidas',
    series: [0, 0, 0],
    labels: ['Cuentas por Pagar', 'Obligaciones Fin.', 'Utilidades Ret.'],
  })

  const [activos, setActivos] =useState([
    { name: 'Activos Corrientes', value: 0, label: "Total Activos Corrientes" },
    { name: 'Activos No Corrientes', value: 0, label: "Total Activos No Corrientes" },
    { name: 'Total Activos', value: 0, label: "Total Activos"},
  ])

  const [pasivos, setPasivos] =useState([
    { name: 'Pasivos Corrientes', value: 0, label: "Total Pasivos Corrientes" },
    { name: 'Pasivo No Corriente', value: 0, label: "Total Pasivos No Corriente" },
    { name: 'Total Pasivos', value: 0, label: "Total Pasivos" },
  ])

  const [utilidadesRetenidas, setUtilidadesRetenidas] = useState([
    { name: 'Utilidades Retenidas', value: 0, label: "Utilidades Retenidas" },
    { name: 'Patrimonio', value: 0, label: "Total Patrimonio" },

  ])


  // const [bgRangeTable, setBgRangeTable] = useState()
  const indiceChart = {
    id: 1,
    name: 'Índice de Apalancamiento',
    series: apalancamientoChart,
    valType: "number"
  };
  const capitalChart = {
    id: 2,
    name: 'Estructura de Capital',
    series: capitalDataChart,
    valType: "number"
  };
  const acidChart = {
    id: 3,
    name: 'Acid Test',
    series: acidTestChart,
    valType: "number"
  };

  const dataTablaFinanciera =     
  {
    header: [
      '01/05/2022',
      '02/05/2022',
      '03/05/2022',
      '04/05/2022',
      '05/05/2022',
      '06/05/2022',
      '07/05/2022',
    ],
    rows: [
      {
        data: ["1. Activos", 1, 2, 3, 4, 5, 6, 7],
        subRows: [
          { data: ["1.1 Activo Corriente", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["1.1.1 Efectivo y Equivalentes de Efectivo", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["1.1.2 Inventario", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["1.1.3 Servicios y otros Pagos Anticipados", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["1.1.4 Impuestos Corrientes", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["1.1.5 Otros Activos Corrientes", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["Totales Activo Corriente", 1, 2, 3, 4, 5, 6, 7], bold: true },
          { data: ["Totales Activo No Corriente", 1, 2, 3, 4, 5, 6, 7], bold: true },
          { data: ["Total Activo", 1, 2, 3, 4, 5, 6, 7], bold: true },
        ],
      },
      {
        data: ["2. Pasivos", 1, 2, 3, 4, 5, 6, 7],
        subRows: [
          { data: ["2.1 Pasivo Corriente", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["2.1.1 Obligaciones Financieras", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["2.1.2 Cuentas por Pagar", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["2.1.3 Impuestos Corrientes", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["2.1.4 Otros Pasivos Corrientes", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["Totales Pasivo Corriente", 1, 2, 3, 4, 5, 6, 7], bold: true },
          { data: ["Totales Pasivo No Corriente", 1, 2, 3, 4, 5, 6, 7], bold: true },
          { data: ["Total Pasivos", 1, 2, 3, 4, 5, 6, 7], bold: true },
        ],
      },
      {
        data: ["3. Patrimonio", 1, 2, 3, 4, 5, 6, 7],
        subRows: [
          { data: ["3.1 Pasivo Corriente", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["3.1.1 Obligaciones Financieras", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["3.1.2 Cuentas por Pagar", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["3.1.3 Impuestos Corrientes", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["3.1.4 Otros Pasivos Corrientes", 1, 2, 3, 4, 5, 6, 7] },
          { data: ["Total Pasivo + Patrimonio", 1, 2, 3, 4, 5, 6, 7], bold: true },
        ],
      },
    ],
  };


  console.log("activos", activos)

  
  return (
    <div>
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      backgroundColor: "background.default",
    }}
  >
    <Container maxWidth={false} sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
      <Box sx={{ flexGrow: 1, paddingTop: 2 }}>
        <Grid container justifyContent="space-between" spacing={3}>
          <Grid item xs={12} md={12}>
            <Collapse in={displayAlert}>
              <Alert severity="warning" variant="outlined" sx={{ bgcolor: 'background.paper', color: '#034787' }} onClose={() => { setDisplayAlert(false); }}>
                Para el mes {month} se proyecta que el
                <span style={{ fontWeight: 'bold', fontSize: '1.05rem' }}> índice de apalancamiento disminuya en un 0.067% </span>
                con relación al mes actual. La empresa está disminuyendo el riesgo de apalancamiento proveniente de
                instituciones financieras al haber generado más utilidades, las cuales están representadas dentro del capital
                de la empresa.
              </Alert>
            </Collapse>
          </Grid>

          <Grid item xs={12} md={10} display="flex" alignItems="center" sx={{ paddingTop: '7px' }}>
            <BusinessIcon sx={{ color: '#001930' }} fontSize="medium" />
            <Typography
              sx={{
                paddingLeft: 1,
                fontWeight: 700,
                fontSize: '1.825rem',
              }}
              color="textSecondary"
            >
              Balance General Proforma
            </Typography>
            <Box ml={1} onClick={() => handleOpenTable(true)} sx={{ cursor: 'pointer', alignSelf: 'end' }}>
              <img src={viewMoreIcon} alt="costos x ventas" width="35px" height="35px" />
            </Box>
          </Grid>

          <Grid item xs={12} md={2} display="flex" alignItems="center">
            <Typography color="#42526E" fontWeight={500} mr={1} display="flex">Fecha</Typography>
            <DatePicker
              minDate={new Date()}
              maxDate={nextDate}
              selected={valueDate}
              locale="es"
              onChange={handleOnDateChange}
              dateFormat="yyyy-MM-dd"
              className={classes.datePicker}
              popperClassName={classes.datePickerPopper}
            />
          </Grid>

          {openTable === true ? (
            <Grid item xs={12}>
              <div ref={bottomRef}>
                <TablaPrior data={tableBgRanges}/>
              </div>
            </Grid>
          ) : (
            <>
              <Grid item xs={12} md={4}>
                <Grid item padding={1}>
                  <WidgetBalance data={activos} />
                </Grid>
                <Grid item padding={1}>
                  <WidgetBalance data={pasivos} />
                </Grid>
                <Grid item padding={1} display="flex">
                  <WidgetBalance data={utilidadesRetenidas} />
                </Grid>
              </Grid>

              <Grid item display="flex" justifyContent="space-evenly" xs={12} md={8}>
                <PastelBalance data={activosCorrientesDeHoy} icon={activoCorrienteIcon} />
                <PastelBalance data={pasivosCorrientesDeuda} icon={pasivoUtilidadesIcon} />
              </Grid>

              <Grid item xs={12} md={12}>
                <ChartCapitalTrabajoCicloEfectivo data={{ capitalTrabajo, conversionEfectivo }} />
              </Grid>

              <Grid item xs={12} md={7}>
                <BarDonutBG info={ifPercentage} selectedIndicator={handleIndicator} />
              </Grid>

              <Grid item xs={12} md={5}>
                <ChartLineZoom
                  data={info}
                  props={
                    currentIndicator === 'CapAcc'
                      ? capitalChart
                      : currentIndicator === 'Acid'
                        ? acidChart
                        : indiceChart
                  }
                />
              </Grid>
            </>
          )}
        </Grid>
      </Box>

      <Box component="footer" sx={{ py: 2 }}>
        <Typography sx={{ fontSize: '1rem' }}>© 2025 Dynamics Within. Todos los Derechos Reservados.</Typography>
      </Box>
    </Container>
  </Box>
</div>
  );
};

export default OverviewBalanceGeneral;